import { render } from "./PrestamoDetail.vue?vue&type=template&id=79873550"
import script from "./PrestamoDetail.vue?vue&type=script&lang=js"
export * from "./PrestamoDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__